import "../packs_common/globalFunctions"

import CookieConsentDialog from "../components/CookieConsentDialog"
import GlobalCategoryNavbar from "../components/GlobalCategoryNavbar"
import Translations from "../components/Translations"
import { ComponentClass, FunctionComponent } from "react"
import ReactOnRails from "../reactOnRails"
ReactOnRails.register({
  "Translations": Translations as FunctionComponent,
  "CookieConsentDialog": CookieConsentDialog as FunctionComponent,
  "GlobalCategoryNavbar": GlobalCategoryNavbar as FunctionComponent,
});

import './application_minimal'
